export default "__VITE_ASSET__k7wFFiDB__"